import React, { useEffect, useState } from 'react'
import styled from "styled-components";
import EduEmp from "./EduEmp";
import PortfolioHeader from "./PortfolioHeader";
import SkillProgress from "./SkillProgress";
import { experienceData,QualificationData,projectData,SkillData,coursesData, hobbyProjects } from "../DataSource/Data";
import ProjectCard from "./ProjectCard";
import CourseCard from "./CourseCard";
import Experience from "./Experience";
import db from '../DataSource/Firebase'
import { useDispatch, useSelector } from "react-redux"
import About from './About';
import { RxBorderBottom, RxBorderWidth } from 'react-icons/rx';

let reverseEdu = [];



const Portfolio = () => {
  const reduxData = useSelector((store)=> store.port.exp)
  const reduxEdu = useSelector((store)=> store.port.edu)
  const reduxProjects = useSelector((store)=> store.port.projects)
  const reduxSkills = useSelector((store)=> store.port.skills)
  const reduxCourses = useSelector((store)=> store.port.courses)
  const reduxHobby = useSelector((store)=> store.port.hobby)
  const [isSelected, setSelected] = useState(true);
 
  if(reduxEdu !== ""){
    reverseEdu = reduxEdu.reverse();
    // alert("portfolio edu>>"+JSON.stringify(reverseEdu))
  }

  // alert(JSON.stringify(reduxData))
  // const [arr, setArr] = useState([])
  // let array = [];
//   useEffect(()=>{
//     // db.collection("experience").doc('p3').set( {
//     //   id: 3,
//     //   title: "Software Developer",
//     //   companyName: "Agile Softech Private Limited", 
//     //   period: "2021-2021",
//     //   location: "Ghaziabad, On-site",
//     //   pointers: [
//     //     'Developed front-end user interface using React Native and Javascript for iOS and Android mobile applications.'
//     //   ]
//     // },);
//   db.collection("experience").get().then((querySnapshot) => {
  
//     querySnapshot.forEach((doc) => {
//       // alert(JSON.stringify(doc))
//         // doc.data() is never undefined for query doc snapshots
//         console.log(doc.id, " => ", doc.data());
//         setArr(()=>[...arr,doc.data()])
//         array.push(doc.data())
//         // alert(doc.data())
//     });
//     setArr(array)
// }).catch((e)=>{
//     alert(e)
//   });

//   },[])

  return (
    <Wrapper>
      <PortfolioHeader />
      <div className="root-container">
      <div className="main-content">
        <div className="left-container">
        <h1 id='exp-target'>About me</h1>
          <div className="item-container">
      <About/>
          </div>
      
          <h1 id='exp-target'>Experience</h1>
          <div className="item-container">
            {reduxData !== "" && reduxData.map((item) => (
              <Experience item={item} />
            ))}
          </div>
          <h1 id='education-target'>Education</h1>
          <div className="item-container">
            {reverseEdu.length > 0 && reverseEdu.map((item) => (
              <EduEmp item={item} />
            ))}
          </div>
          <div className="right-container">
            <h1 id='skills-target'>Professional Skills</h1>
            <div className='skill-container'>
            {reduxSkills !== "" &&  reduxSkills.map((item)=> <SkillProgress item={item} />)}
            </div>
            
          </div>
        
        </div>
       
      </div>
    
    <div className='tab-container'>
        <h1 id='project-target' className={isSelected ? 'selected' : 'unselected'} onClick={()=> setSelected(!isSelected)}>Projects</h1>
        <div className='hobby'>
        <h1 id='project-target'  className={!isSelected ? 'selected' : 'unselected'} onClick={()=> setSelected(!isSelected)}>Hobby Projects</h1>
        </div>
    </div>
   
         {
          isSelected ?
          <div className="item-container">
          { reduxProjects !== "" &&  reduxProjects.map((item) => (
            <ProjectCard item={item} />
          ))}
        </div>
        :
        <div className="item-container">
        { reduxHobby !== "" &&  reduxHobby.map((item) => (
          <ProjectCard isFromHobby={true} item={item} />
        ))}
      </div>
         }
          <h1 id='courses-target'>Courses</h1>
          <div className="item-container">
            {reduxCourses !== ""  && reduxCourses.map((item) => (
              <CourseCard item={item} />
            ))}
          </div>
          </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
.root-container{
  width: 80%;
    margin: auto;
}
.cursor{
  cursor: pointer;
}
.selected{
  border-bottom: 1px solid #D40B7E;
  padding-bottom: 0.2rem;
  color: #D40B7E;
  cursor: pointer;
}
.unselected{
  border-bottom: 0px solid white;
  color: gray;
  cursor: pointer;
}

  .main-content {

    /* background-color: red; */
    /* display: grid;
    grid-template-columns: repeat(2,1fr); */
  }
  .hobby{
    margin-left: 0.6rem;
  }
  .tab-container{
    display: flex;
  }
  h1 {
    margin-top: 1rem;
    font-size: medium;
    color: gray;
    /* margin-left: 2rem; */
  }

  .item-container {
    margin-top: 1rem;
    /* width: 80%;
margin: auto; */
  }
  .progress-container{
    background-color: lightgray;
    width: 100%;
    height: 0.4rem;
    border: 1px solid lightgray;
  }
  .progress-inner{
    background-color: #D40B7E;
    width: 30%;
    height: 0.4rem;
    border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem;

  }
  .right-container{
    margin-bottom: 2rem;

  }
  .skill-container{
    display: grid;
    grid-template-columns: repeat(2,2fr);
    grid-column-gap: 2rem;
  }
  @media (max-width: 500px) {
    .main-content {
      display: flex;
      flex-direction: column;
    }
    .skill-container{
    display: flex;
    flex-direction: column;
  }
  .root-container{
  width: 90%;
}
  }
`;

export default Portfolio;
